export default "__VITE_PUBLIC_ASSET__913d73c6__"